import { ENTRIES_LOADED } from '../constants';

export default function update(state = {byContentfulId:{}, all:[]}, action) {
    switch (action.type) {
        case ENTRIES_LOADED:
            if(action.entries.subscribersCornerEntry) {
                let result = {byContentfulId:{}, all:[]}
                Object.keys(action.entries.subscribersCornerEntry).forEach(k => {
                    let it = action.entries.subscribersCornerEntry[k]
                    if (it && it._id) {
                        result.byContentfulId[it._id] = it
                        result.all.push(it)
                    }
                })
                return result
            }
            break;
    }
    return state;
}
